@if (!isDisabled) {
  @switch (state) {
    @case (SelectAccountState.UNKNOWN) {
      <div class="account-display-name">{{displayAccount?.name}}</div>
    }
    @case (SelectAccountState.ENABLED) {
      <select-input-object
        class="account-type_select"
        [ngModel]="accountBase"
        (ngModelChange)="onChangeAccountBase($event)"
        [selectMenuItems]="accountBaseSelectItems">
      </select-input-object>
    }
    @case (SelectAccountState.NOT_SUPPORTED) {
      <div class="account-coming-soon">{{'components.select-account.coming_soon' | l10n}}</div>
    }
    @case (SelectAccountState.SMART) {
      <div class="account-display-name">{{'components.select-account.smart_account' | l10n}}</div>
    }
    @case (SelectAccountState.ACCOUNT_NEEDED) {
      @if (canManageAccounts && !isDetachedWidget) {
        <a class="create-account-link"
          [routerLink]="['/accounts', 'create']"
        [queryParams]="{exchange: accountCreationLinkExchange}">{{'components.select-account.create_account_link' | l10n}}</a>
      } @else {
        <a class="create-account-link_is-detached">{{'components.select-account.create_account_link' | l10n}}</a>
      }
    }
  }
} @else {
  <div class="account-display-name">{{displayAccount?.name}}</div>
}
